import React, { ReactNode } from 'react'
import Block from '../primitives/Block'
import Box, { BoxProps } from '../primitives/Box'
import Row from '../primitives/Row'
import Stack from '../primitives/Stack'
import Button from '../system/Button'

export type HoverMenuItemProps = {
  icon: string
  title: string
  content: string
  href: string
}

export function HoverMenu(props: {
  items: HoverMenuItemProps[]
  width?: BoxProps['width']
  spreadItems?: boolean
  children: ReactNode
}) {
  return (
    <Block
      position="absolute"
      left="50%"
      transform="translateX(-50%)"
      zIndex={100}
      paddingTop={16}
    >
      <Box
        borderRadius={32}
        display="flex"
        width={props.width}
        overflow="hidden"
        boxShadow="strong"
      >
        <Row>
          <Stack
            width="100%"
            height="100%"
            backgroundColor="white"
            paddingTop={48}
            paddingX={48}
            space={props.spreadItems ? 8 : 0}
          >
            {props.items.map(page => (
              <HoverMenuItem {...page} key={page.href} />
            ))}
          </Stack>
          <Box position="relative" flexShrink={0} backgroundColor="white">
            {props.children}
          </Box>
        </Row>
      </Box>
    </Block>
  )
}

export function HoverMenuItem(props: HoverMenuItemProps) {
  const isExternal = props.href.startsWith('http')
  return (
    <Button
      paddingX={8}
      paddingY={12}
      width={360}
      borderRadius={16}
      variant="hoverHighlight"
      href={props.href}
      display="flex"
      alignItems="center"
      target={isExternal ? '_blank' : undefined}
    >
      <Box gap={8} display="flex">
        <Box display="flex" alignItems="start">
          <img src={props.icon} alt={props.title} />
        </Box>
        <Stack>
          <Row>
            <Box font="h5">
              {props.title}
              {isExternal ? <ExternalLinkIcon /> : <></>}
            </Box>
          </Row>
          <Row>
            <Box font="small" color="black600">
              {props.content}
            </Box>
          </Row>
        </Stack>
      </Box>
    </Button>
  )
}

const ExternalLinkIcon = () => (
  <Box.span style={{ paddingTop: '5px', paddingLeft: '4px' }}>↗</Box.span>
)
